import { render } from "./roleManage.vue?vue&type=template&id=9a21cf64"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"

import "./roleManage.vue?vue&type=style&index=0&id=9a21cf64&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__